import React from 'react';
import { MessageCircle } from 'lucide-react';

const ChatButton = () => {
  const handleChatClick = () => {
    // Opens SMS app with pre-filled number
    window.location.href = 'sms:+16788797117';
  };

  return (
    <button
      onClick={handleChatClick}
      className="fixed bottom-6 right-6 z-40 w-16 h-16 bg-[#D7AC78] text-white rounded-full shadow-2xl hover:bg-[#c49a68] transform hover:scale-110 transition-all duration-300 flex items-center justify-center group"
      aria-label="Send us a message"
    >
      <MessageCircle size={28} className="group-hover:animate-pulse" />
      
      {/* Tooltip */}
      <span className="absolute right-full mr-3 px-3 py-2 bg-[#484237] text-white text-sm font-medium rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap shadow-lg">
        Send us a message
      </span>
      
      {/* Pulse animation */}
      <span className="absolute inset-0 rounded-full bg-[#D7AC78] animate-ping opacity-20"></span>
    </button>
  );
};

export default ChatButton;
